import api from "./api";

export const approveLegalReview = async (contractId, comment) => {
    const res = await api.post(`/legalreview/${contractId}/approve`, {
        comment,
    });

    return res.data;
};

export const rejectLegalReview = async (contractId, comment) => {
    const res = await api.post(`/legalreview/${contractId}/reject`, {
        comment,
    });

    return res.data;
};

export const getLegalReviews = async () => {
    const res = await api.get("/legalreview");
    return res.data;
};

export default {
    approveLegalReview,
    rejectLegalReview,
    getLegalReviews,
};